import type { ComponentProps } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { PoweredByRotowire } from '@sorare/core/src/components/rotowire/PoweredByRotowire';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';

import { ProjectionScoreIcon } from '#src/searchCommonPlayer/StatsManager/Projections/ProjectionScoreIcon/index.tsx';

export type Projection =
  | typeof So5FixtureEvent.CLASSIC
  | typeof So5FixtureEvent.DAILY;

const tooltipMessages: Record<Projection, MessageDescriptor> = {
  [So5FixtureEvent.DAILY]: scoutingCenter.projectionDailyTooltip,
  [So5FixtureEvent.CLASSIC]: scoutingCenter.projectionClassicTooltip,
};

type Props = {
  mode: Projection;
  color?: ComponentProps<typeof LabelS>['color'];
};

export const ProjectionLabel = ({ mode }: Props) => {
  return (
    <Tooltip
      title={
        <LabelS className="text-center">
          <FormattedMessage
            {...tooltipMessages[mode]}
            values={{ rotowireLogo: <PoweredByRotowire /> }}
          />
        </LabelS>
      }
    >
      <ProjectionScoreIcon so5FixtureEvent={mode} />
    </Tooltip>
  );
};
